import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import CMSPage from "./components/CMSPage";
import CMSLogin from "./components/cms/CMSLogin";
import RequireAuth from "./components/cms/RequireAuth";
import TeamManagementPage from "./components/cms/TeamManagementPage";
import PortfolioManagementPage from "./components/cms/PortfolioManagementPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/cms/login" element={<CMSLogin />} />
          <Route
            path="/cms"
            element={
              <RequireAuth>
                <CMSPage />
              </RequireAuth>
            }
          />
          <Route
            path="/cms/team"
            element={
              <RequireAuth>
                <TeamManagementPage />
              </RequireAuth>
            }
          />
          <Route
            path="/cms/portfolio"
            element={
              <RequireAuth>
                <PortfolioManagementPage />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;